(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thp-welcome-subscribe"] && !Shopify.designMode) return;
  try {
    //kartra form script
src="https://app.kartra.com/optin/QGkpwsXUJd9c">

//popup timer
  document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('WelcomePopup');
    const closeBtn = document.querySelector('.close-popup-btn');
    const hasVisited = localStorage.getItem('hasVisitedStore');
        if (!hasVisited) {
            setTimeout(() => {
            popup.style.display = 'block';
            localStorage.setItem('hasVisitedStore', 'true');
            }, 30000);
        }
        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
            popup.style.display = 'none';
            });
        }
        window.addEventListener('click', function(event) {
            if (event.target === popup) {
            popup.style.display = 'none';
            }
        });
    });
  } catch(e) { console.error(e); }
})();

})();
